// extracted by mini-css-extract-plugin
module.exports = {"next":"_3G8v-Hk"};